import { useParams } from "react-router-dom";
import WeeklyCheckInAdminConsoleSettings from "./WeeklyCheckInAdminConsoleSettings";
import CoachBoAdminConsoleSettings from "./CoachBoAdminConsoleSettings";
import GeneralAdminConsoleSettings from "./GeneralAdminConsoleSettings";
import TeamScanAdminConsoleSettings from "./TeamScanAdminConsoleSettings";
import EPPAdminConsoleSettings from "./EPPAdminConsoleSettings";
import PlatformIntegrations from "./Cards/PlatformIntegrations";
import FileSyncIntegrationAdminConsoleSettings from "./FileSyncIntegrationAdminConsoleSettings";

export default function AdminConsoleSettings() {
  const urlParams = useParams();
  const subTabSelected = urlParams.subTabSelected;

  const getBody = () => {
    switch (subTabSelected) {
      case "Coach Bo":
        return <CoachBoAdminConsoleSettings />;
      case "TEAMscan":
        return <TeamScanAdminConsoleSettings />;
      case "EPP":
        return <EPPAdminConsoleSettings />;
      case "Check-Ins":
        return <WeeklyCheckInAdminConsoleSettings />;
      case "Integrations":
        return <PlatformIntegrations />;
      case "File Sync":
        return <FileSyncIntegrationAdminConsoleSettings />;
      case "General":
      default:
        return <GeneralAdminConsoleSettings />;
    }
  };

  return <div className="column-gap-20px">{getBody()}</div>;
}
